// Console action feedback 0.1.155; 2026-10-28 18:11:13 CST; parent 44dbda7a05c960e3c79c6c322d676ac5e4982b20.
/** Success means the browser actually accepted the copy, including the legacy fallback. */
export async function writeClipboardText(value: string): Promise<void> {
  if (!value) throw new Error('暂无可复制的内容')
  if (navigator.clipboard?.writeText) {
    try { await navigator.clipboard.writeText(value); return } catch { /* Try compatible copy. */ }
  }
  const previous = document.activeElement
  const input = document.createElement('textarea')
  input.value = value
  input.setAttribute('readonly', 'true')
  input.style.position = 'fixed'; input.style.opacity = '0'
  document.body.appendChild(input)
  try {
    input.select()
    if (!document.execCommand('copy')) throw new Error('浏览器未允许自动复制，请手动选择内容复制。')
  } finally {
    input.remove()
    if (previous instanceof HTMLElement && previous.isConnected) previous.focus({ preventScroll: true })
  }
}
